<div class="row" *ngIf="Switcher_view==-1">
  <div class="col-xl-4 mb-30">

     <div class="card card-statistics">
     <div class="card-body">
       <div class="card-title" >
        <div class="float-right">
          <select class="custom-select" (change)="ReadData_Ticket()"
            [(ngModel)]="Show_Draft_Ticket" name="Show_Draft_Ticket">
            <option value="0">All</option>
            <option value="1">Awaiting Reply</option>
          </select>
        </div>
    
         <h6 *ngIf="!Proccessing">Tickets ({{Ticket_Datalist.length}} items)</h6>
         <h6 *ngIf="Proccessing">Tickets (Loading...)</h6>
        </div>

       <!-- action group -->
      
       <div class="scrollbar" style="max-height: 500px;">
        <ul class="list-unstyled">
          <li class="mb-15" *ngFor="let item of Ticket_Datalist
          | paginate: {
              id: 'DataList_FeildTable',
              itemsPerPage: 6,
              currentPage: page,
              totalItems: Ticket_Datalist.length
            }" style="cursor: pointer;" (click)="ReadData_Ref_Ticket(item)">
            <div class="media">

              <div class="media-body">
                 <h6 *ngIf="!item.selected" class="mt-0 "> {{item.title}}  <small style="color: blue;font-weight: bolder;" *ngIf="item.isNew" class="float-right">New</small> </h6>
                 <h6 *ngIf="item.selected" style="text-decoration: underline;font-style: italic;font-weight: bold;" class="mt-0 "> {{item.title}}  </h6>
                 <p>{{item.cateTitle}} <small class="float-right"> Ticket Number  {{item.code}}</small>  </p>
              </div>
            </div>
            <div class="divider mt-15"></div>
          </li>

        </ul>
      </div>
      <pagination-controls
      id="DataList_FeildTable"
      nextLabel="Next"
      previousLabel="Previous"
      (pageChange)="page = $event"
      ></pagination-controls>
      <button *ngIf="typeUser=='3' || typeUser=='4'" routerLink="/TicketForm" type="button" class="btn btn-success" ><i class="fa fa-plus-circle" ></i> Create Ticket </button>
      <button *ngIf="typeUser=='1' || typeUser=='2'" routerLink="/TicketAdminForm" type="button" class="btn btn-success" ><i class="fa fa-plus-circle" ></i> Create Ticket </button>
      </div>
    </div>
  </div>
  <div class="col-xl-8 mb-30">

    <div class="card tickets">
     <div class="card-body">
       <h5 class="card-title" *ngIf="Seleted_Ticket_Item.id>0">Ticket Conversation 'Number {{Seleted_Ticket_Item.code}} '</h5>
       <h5 class="card-title" *ngIf="Seleted_Ticket_Item.id==0">Ticket Conversation 'No ticket selected'</h5>

       <button *ngIf="Seleted_Ticket_Item.id>0 && canReply" (click)="Show_View_ReplyForm()" type="button" class="btn btn-info" ><i class="fa fa-plus" ></i> Reply to Ticket </button>
       <br/>
       <br/>
       <div class="scrollbar max-h-550 tickets-info">
        <ul class="list-unstyled" *ngIf="Seleted_Ticket_Item.id>0">
          <li class="mb-15" *ngFor="let item of Ticket_Datalist_Ref">
            <div class="media">
             <div class="position-relative">
              <img class="img-fluid mr-15 avatar-small" src="{{BaseUrl}}{{item.image}}" alt="">
              <i class="avatar-online bg-success"></i>
             </div>
              <div class="media-body" >
                 <h6 class="mt-0 "> {{item.fullname}} <small class="float-right">{{item.persianDate}}</small> </h6>

                 <div innerHTML="{{item.message}}"></div>

                 <div *ngIf="item.files.length>0">
                   <ng-container *ngFor="let file of item.files">
                     <br/>
                      <a class="btn btn-danger" target="_blank" href="{{BaseUrl}}File/Ticket/{{file}}" style="font-size: 12px;color: white;"  ><i class="fa fa-download"></i> Download File Number {{item.files.indexOf(file)+1}} </a>
                   </ng-container>

                 </div>

              </div>

            </div>
            <div class="divider mt-15"></div>
          </li>

        </ul>
       </div>
      </div>
    </div>
  </div>
</div>

<app-TicketReply *ngIf="Switcher_view==0"
(OnBack_Ticket_Action)="OnGet_Back_Ticket($event)"
[Ticket_Selected]="Seleted_Ticket_Item"
>

</app-TicketReply>
